// API مربوط به پروفایل کاربر
// این فایل فقط مسئول ارتباط با سرور است، هیچ منطق UI اینجا نیست

import { httpClient } from "./httpClient";

// دریافت اطلاعات پروفایل کاربر لاگین‌شده
export function getProfile() {
  return httpClient.get("/user/me");
}

// ویرایش اطلاعات پروفایل
export function updateProfile(userId, profileData) {
  return httpClient.patch(`/user/${userId}`, profileData);
}

// تغییر رمز عبور
export function changePassword({ oldPassword, newPassword }) {
  return httpClient.post("/user/change-password", {
    oldPassword,
    newPassword,
  });
}
